import React from "react"
import {
  Box,
  IconWithBackground,
  InternalIcon,
  Link,
  MapIcon,
  Stack,
  Tile,
  Typography,
  useTheme,
  SurfaceColor
} from "@carrotfertility/carotene-core"
import { FormattedMessage, useIntl } from "react-intl"
import { Link as RouterLink } from "react-router-dom"
import { DbgPaths } from "#/utils/Paths"

export default function CarrotRxHomeSidebarModule({ color = "primary" }: { color?: SurfaceColor }): JSX.Element {
  const intl = useIntl()
  const theme = useTheme()

  return (
    <Tile variant="secondary" color={color} id="home-sidebar-carrot-rx-module">
      <Stack spacing={theme.spacing(theme.tokens.spacing.lg)} alignItems="flex-start">
        <Box
          component="img"
          src={"/images/carrot-rx-logo.svg"}
          aria-label={intl.formatMessage({
            defaultMessage: "Carrot Rx logo",
            description: "Accessibility label for a logo that reads 'Carrot Rx'"
          })}
          sx={{
            blockSize: "14px"
          }}
        />
        <Typography variant="body1" color={(theme) => theme.palette.text.secondary}>
          <FormattedMessage defaultMessage="Carrot Rx offers significant savings on medication and convenient delivery to your home." />
        </Typography>
        <Link
          id="home-sidebar-carrot-rx-module-link"
          component={RouterLink}
          to={DbgPaths.PHARMACY}
          startIcon={<IconWithBackground icon={MapIcon} color={color} />}
          endIcon={<InternalIcon color="primary" fontSize="small" />}
        >
          <FormattedMessage defaultMessage="Explore your pharmacy benefit" />
        </Link>
      </Stack>
    </Tile>
  )
}
